import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c3e1b51c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "edit-left-title" }, "智能解析", -1))
const _hoisted_3 = { class: "edit-btns" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("识别")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("清除")
const _hoisted_6 = { class: "edit-right flex1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_CitySelect = _resolveComponent("CitySelect")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createBlock(_component_el_form_item, {
      class: "edit-left flex1",
      labelWidth: "0"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_el_input, {
          type: "textarea",
          placeholder: "粘贴地址信息到此处，系统自动帮您填写（例如：张三 19343435342 上海市青浦区华新镇2号）",
          rows: "4",
          resize: "none",
          modelValue: _ctx.newInfo,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newInfo) = $event)),
          onBlur: _ctx.handleTrim
        }, null, 8, ["modelValue", "onBlur"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "mini",
            disabled: !_ctx.newInfo,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleIdentify(_ctx.newInfo)))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            size: "mini",
            plain: "",
            disabled: !_ctx.newInfo,
            onClick: _ctx.handleClear
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ]),
      _: 1
    })), [
      [_directive_loading, _ctx.loading]
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_el_form_item, {
        label: "姓名",
        prop: "customerName"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            placeholder: "请输入姓名",
            modelValue: _ctx.editFormData.customerName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editFormData.customerName) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "联系方式",
        prop: "customerPhone"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            placeholder: "请输入联系方式",
            modelValue: _ctx.editFormData.customerPhone,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editFormData.customerPhone) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "省市区",
        class: "is-required",
        prop: "address"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_CitySelect, {
            defaultProvinceObj: _ctx.defaultProvinceObj,
            defaultCityObj: _ctx.defaultCityObj,
            defaultCountyObj: _ctx.defaultCountyObj,
            onCityChange: _ctx.handleCityChange
          }, null, 8, ["defaultProvinceObj", "defaultCityObj", "defaultCountyObj", "onCityChange"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "详细地址",
        prop: "detailsAddress"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            placeholder: "请输入详细地址",
            maxlength: "512",
            type: "textarea",
            rows: "4",
            modelValue: _ctx.editFormData.detailsAddress,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editFormData.detailsAddress) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ])
  ]))
}